export class RemoteDefinitionsLeftError extends Error {
  constructor() {
    super(`All remote definitions must be filled successfully`);
    this.name = 'RemoteDefinitionsLeftError';
  }
}
